import { Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

import { MenuItem, DataTable } from 'primeng/primeng';

import { CUIGridColumn } from './cui-grid-column';
import { Subscription } from 'rxjs/Subscription'; 
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'cui-grid',
    templateUrl: './cui-grid.component.html'
})
export class CUIGridComponent {
    @Input() columns: CUIGridColumn[] = [];
    @Input() contextMenu: MenuItem[] = [];
    @Input() data: any[] = [];
    @Input() identityColumn: string = 'id';
    @Input() rowsPerPage: number = 10;
    @Input() selection: any[] = [];
    @Input() totalRecords: number = 0;
    @Input() filterDelay: number = 1500;
    @Input() enableCheckbox: boolean = true;
    @Input() enableContextMenu: boolean = true;
    @Input() sortField: string;
    @Input() sortOrder: number = 1;
    @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
    @Output() selectionChange: EventEmitter<any> = new EventEmitter();
    @Output() onClick: EventEmitter<any> = new EventEmitter();
    @Output() onContextMenuSelect: EventEmitter<any> = new EventEmitter();
    @ViewChild('dataTable') private dataTable: DataTable;

   
    filterTimeout = null;
    globalFilter: string;
    selectionMode: string;
    lazyloadTimer: any;
    lazyloadTimerSubscription: Subscription;
    routeSubscription: Subscription;
    ngOnInit(): void {
        this.selectionMode = this.enableCheckbox ? 'multiple' : 'single';
        this.subscribeToRouteParamChanges();
    }
    ngOnDestroy(): void {
        this.routeSubscription.unsubscribe();
    }
    constructor(private route: ActivatedRoute ) {

}
    /**
     * @function emits a onClick event to the implementing feature component when the button link is clicked
     * @returns void
     */
    emitClick(value: string): void {
        this.onClick.emit({ value: value });
    }

    /**
     * @function emits a onLazyLoad event to the implementing feature component
     * @returns void
     */
    emitLazyLoad(event): void {
        try {

            //MM - Bug 138284 - Added sliding timer to prevent frequent calls to API...
            if (this.lazyloadTimerSubscription) {
                this.lazyloadTimerSubscription.unsubscribe();
                this.lazyloadTimerSubscription = null;
            }
            this.lazyloadTimer = null;
            this.lazyloadTimer = Observable.timer(1500);
            this.lazyloadTimerSubscription = this.lazyloadTimer.subscribe(t => {

                this.onLazyLoad.emit({
                    filter: this.globalFilter,
                    first: event.first,
                    rows: event.rows,
                    sortField: event.sortField,
                    sortOrder: event.sortOrder,
                });


            });


        }
        catch (e) {

            if (this.lazyloadTimer) {
                this.lazyloadTimer = null;
                if (this.lazyloadTimerSubscription) {
                    this.lazyloadTimerSubscription.unsubscribe();
                }
                this.lazyloadTimerSubscription = null;

            }
        }
        
    }

    /**
     * @function emits a onSelectionChange event to the implementing feature component
     * @returns void
     */
    emitSelection(event): void {
        this.selectionChange.emit(event);
    }

    emitContextMenu(event): void {
        this.onContextMenuSelect.emit(event);
    }

    private subscribeToRouteParamChanges() {
        this.routeSubscription = this.route.parent.params.subscribe(params => {
            this.dataTable.reset();
        });
    }

    checkSortableColumn(column:any):boolean {

        return (column.sortable !== undefined) ? column.sortable : true;

    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-grid/cui-grid.component.ts